import { Layout, Title, Paragraph, Button } from 'components';
import React from 'react';
import { AuthContext, AuthContextType } from 'contexts';
import styled from 'styled-components';
import { Button as ButtonV2 } from '@bb/elements-web-rebranding';
import { featureEnabled } from 'utils';
import { SupraLogo } from 'components/SideMenu/StyledComponents';
import logo from '../../../img/logo_v2.svg';
import errorImage from '../../../img/error_screen.svg';

const NonMemberRestrictionPage = () => {
  const { logout } = React.useContext<AuthContextType>(AuthContext);
  const hasSupraRebrandingFeature = featureEnabled('supraRebrandingFeature', 1);
  return (
    <Layout>
      <StyledContent>
        {hasSupraRebrandingFeature ? (
          <SupraLogo />
        ) : (
          <div className="brokerbay-logo"></div>
        )}
        <div className="wrapper">
          <div className="illustration"></div>
          <Title>You don&apos;t have access to web app.</Title>
          <Paragraph>
            Please use our mobile app to access the platform.
          </Paragraph>
          {hasSupraRebrandingFeature ? (
            <ButtonV2
              dataCy="logout-button"
              onClick={logout}
              styleOverride={{ minWidth: '85px' }}
            >
              Logout
            </ButtonV2>
          ) : (
            <Button type="primary" size="large" onClick={logout}>
              Logout
            </Button>
          )}
        </div>
      </StyledContent>
    </Layout>
  );
};

export default NonMemberRestrictionPage;

const StyledContent = styled(Layout.Content)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  min-height: 100vh;
  padding: 22px 40px;
  background-color: #fafafa;

  .brokerbay-logo {
    width: 100%;
    max-width: 130px;
    padding: 10px;
    margin-bottom: 145px;
    background-image: url(${logo});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .illustration {
    width: 100%;
    max-width: 218px;
    height: 137px;
    margin-bottom: 24px;
    background-image: url(${errorImage});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
  }

  .ant-btn {
    margin-top: 24px;
    font-weight: 400;
  }
`;
